export const defaultEvents = [
  {
    event_name: 'my_event',
    key_field_name: 'id',
    fields: [
      {
        name: 'id',
        generation: {
          generator: 'Number.iterating-integer',
          arguments: [1, 1],
        },
      },
      {
        name: 'name',
        generation: {
          generator: 'Person.full-name',
          arguments: [],
        },
      },
      {
        name: 'age',
        generation: {
          generator: 'Number.number-between',
          arguments: ['2', '80', 'INTEGER']
        },
      },
    ],
  },
]

export const defaultTopicsMap = new Map<string, string>().set('my_event', 'my_topic')
export const defaultIdsMap = new Map<string, string>().set('my_event', 'id')
